import React, { useEffect, useMemo, useRef } from 'react';
import SvgIcon from '@home/components/SvgIcon';
import { sortArrayAuxiliaryFunc } from '@op/utils';
import { allTimeFormatObj } from '@op/utils/time';
import { PromptConfirmItemType } from '@op/components/GPT/types';
import { AiIconMap, DEFAULT_MODAL } from '@op/components/GPT/constants';
import { Icon } from 'tea-component';
import useIntersectionObserver from '@op/pages/Summary/hooks/useIntersectionObserver';
import moment from 'moment';

export function ReportHeaderTitle({
  promptInfo,
  downloadAdvanceComments,
  formatMessage,
  downloadText = 'Download Original Comments',
  loading = false,
  setShow,
  hasResult
}: {
  promptInfo: PromptConfirmItemType;
  downloadAdvanceComments: any;
  formatMessage: any;
  downloadText?: string;
  loading?: boolean;
  setShow?: any;
  hasResult: boolean;
}) {
  const { modelType = DEFAULT_MODAL, gptOptions } = promptInfo;
  const icon = AiIconMap[modelType];
  const titleRef = useRef<HTMLDivElement>(null);
  const { show } = useIntersectionObserver({
    target: titleRef.current,
    threshold: 1,
    defaultValue: true
  });

  useEffect(() => {
    setShow?.(show);
  }, [setShow, show]);

  return (
    <div className={`dbo-gpt-summary-preview-title`} ref={titleRef}>
      <span className="item-title">
        {icon && <img src={icon} className="item-icon" />}
        {formatMessage({ id: 'Summary' })}
      </span>
      {/* {(gptOptions === 'advanced' && hasResult) && (
        <span
          className="item-subtitle"
          onClick={() => {
            downloadAdvanceComments?.();
          }}
        >
          {loading ? (
            <Icon type={'loading'} className='loading-icon' />
          ) : (
            <SvgIcon type={'download'} className="card-slot-charicon" />
          )}
          {formatMessage({ id: downloadText })}
        </span>
      )} */}
    </div>
  );
}

export const ReportHeader = (props: {
  formatMessage: any;
  filter: any;
  commentList: any;
  socialList: any;
}) => {
  const { formatMessage, filter, commentList, socialList } = props;

  const timeRange = useMemo(() => {
    const link_text = ` ${formatMessage({ id: 'to' })} `;
    const format = allTimeFormatObj.hourly;
    return moment(filter?.start_time).format(format) +
      link_text +
      moment(filter?.end_time).format(format);
  }, [filter]);

  const upperExceptEtc = (str: string) =>
    str
      .split(', ')
      .map((word) =>
        word.toLowerCase() === 'etc'
          ? word
          : word.charAt(0).toUpperCase() + word.slice(1),
      )
      .join(', ');

  const channelCovered = useMemo(() => {
    const { channel_comments = [], channel_social = [] } = filter;

    const emptyComments = channel_comments?.includes('-99999');
    const emptySocial = channel_social?.includes('-99999');
    const channelList = [
      ...(emptySocial ? [] : socialList ?? []),
      ...(emptyComments ? [] : commentList ?? []),
    ];

    const combined = [
      ...(emptySocial ? [] : channel_social ?? []),
      ...(emptyComments ? [] : channel_comments ?? []),
    ].sort(sortArrayAuxiliaryFunc(channelList));

    const displayCount = 3;

    if (combined.length === 0) {
      const fallback = channelList ?? [];
      if (fallback.length === 0) {
        return '';
      }
      return fallback.length > displayCount
        ? [...fallback.slice(0, displayCount), 'etc'].join(', ')
        : fallback.join(', ');
    }

    return combined.length > displayCount
      ? [...combined.slice(0, displayCount), 'etc'].join(', ')
      : combined.join(', ');
  }, [filter, commentList, socialList]);

  return (
    <div className={'gpt-summary-header'}>
      <div className={'time-range'}>
        {formatMessage({ id: 'Time Range' })}: {timeRange}
      </div>
      {channelCovered && (
        <div className={'channel-covered'}>
          {formatMessage({ id: 'Channel Covered' })}:{' '}
          {upperExceptEtc(channelCovered)}
        </div>
      )}
    </div>
  );
};
